<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div v-if="userPermissions.indexOf('add_location_departments') > -1" class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name">Department List</div>
                <button type="submit" v-on:click.prevent="addDepartment" class="btn btn-primary waves-effect pull-right">Add</button>
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <div class="app-filter-good-table-container">
                    <!-- List Content Here -->
                    <vue-good-table
                        ref="DepartmentList"
                        mode="remote"
                        title="Department List"
                        @on-page-change="onPageChange"
                        @on-selected-rows-change="selectionChanged"
                        @on-column-filter="onColumnFilter"
                        @on-per-page-change="onPerPageChange"
                        @on-sort-change="onSortChange"
                        :totalRows="totalRecords"
                        :columns="columns"
                        :rows="rows"
                        :pagination-options="{
                        enabled: true,
                        mode: 'pages',
                        pageLabel: 'Page',
                        position: 'bottom',
                        perPage: serverParams.perPage,
                        perPageDropdown: [25, 50, 100, 200 ,500],
                        dropdownAllowAll: false,
                        }"
                        :select-options="{
                        enabled: true,
                        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                        selectionInfoClass: 'custom-class',
                        selectionText: 'rows selected',
                        clearSelectionText: 'Clear',
                        }"

                        :search-options="{
                        enabled: false,
                        }">

                        <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                            <div :key="key">
                                <!--class="btn btn-xs btn-primary"-->
                                <div v-if="props.column.field == 'action'" class="table-action">
                                    <router-link title='Edit Department' class="btn edit-btn-vvg waves-effect pull-left" v-bind:to="{name: 'UpdateDepartment',params:{id:props.row.id}}"><i class="fa fa-pencil" aria-hidden="true"></i></router-link>                                    
                                    <template v-if="props.row.departmentIsActive == 1">
                                        <button class="btn edit-btn-vvg waves-effect pull-left manageicon" v-on:click.prevent="activeOrInactiveState(props.row.id, 'inactive')">
                                            <i title="make inactive" class="fa fa-eye-slash" aria-hidden="true"></i>
                                        </button>
                                    </template>
                                    <template v-else>
                                        <button class="btn edit-btn-vvg waves-effect pull-left manageicon" v-on:click.prevent="activeOrInactiveState(props.row.id, 'active')">
                                            <i title="make active" class="fa fa-eye" aria-hidden="true"></i>
                                        </button>
                                    </template>
                                    <!-- <button class="btn edit-btn-vvg waves-effect pull-left manageicon" v-on:click.prevent="deleteDepartment(props.row.id)">
                                        <i title="make inactive" class="fa fa-trash" aria-hidden="true"></i>
                                    </button> -->
                                </div>
                                <div v-else>
                                    {{props.formattedRow[props.column.field]}}
                                </div>
                            </div>
                        </template>
                        <div slot="selected-row-actions">
                            <template>
                                <button id="deleteGroupBtn" v-on:click.prevent="activeOrInactiveState(0, 'inactive')" class="btn btn-success waves-effect row-deactivate-btn">Deactivate</button>
                                <button id="deleteGroupBtn" v-on:click.prevent="activeOrInactiveState(0, 'active')" class="btn btn-success waves-effect row-activate-btn">Activate</button>
                                <button id="deleteGroupBtn"  v-on:click.prevent="deleteDepartment(0)" class="btn btn-success waves-effect row-activate-btn">Delete</button>
                            </template>
                        </div>
                    </vue-good-table>
                </div>
            </div>
            <!--page content-->
        </div>
        <div v-else class="container-fluid xyz">
            <div class="page-name">
                Oops...!
            </div>
            <div class="admin-page-content">
                Sorry, You don't have permission to access this page.
            </div>
        </div>
        <app-backend-footer></app-backend-footer>
    </div>
    <!-- /#page-content-wrapper -->
</template>

<script>
    import Vue from 'vue';
    import BackendFooter from '@/components/backend/partials/Footer';
    import VueGoodTable from 'vue-good-table';
    import 'vue-good-table/dist/vue-good-table.css';
    Vue.use(VueGoodTable);
    import EventBus from '../../event-bus';
    import SessioMixin from '../../../mixins/sessionmixin';
    import { HTTP } from '../../../http-common';

    var self;
    export default {
        name: 'DepartmentList',
        components: {
            'app-backend-footer': BackendFooter,
        },
        mixins: [SessioMixin],
        data() {
            return {
                isShowLoggedinfields: true,
                userPermissions: ['add_location_departments'],
                roleId: 0,
                roleName: 0,
                system_year: '',
                sitesArr: [],
                firstLoad: 0,
                columns: [
                    {
                        label: 'Department Name',
                        field: 'departmentName',
                        filterable: true,
                        sortable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Department Name", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Department Alias',
                        field: 'departmentAlias',
                        filterable: true,
                        sortable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Department Alias", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Location',
                        field: 'location_name',
                        filterable: true,
                        sortable: false,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Location", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Updated At',
                        field: 'departmentUpdatedAt',
                        filterable: true,
                        sortable: true,
                        filterOptions: {
                            // placeholder: "MM/DD/YYYY",
                            enabled: true, // enable filter for this column
                            placeholder: "MM/DD/YYYY", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Updated By',
                        field: 'updated_by',
                        filterable: true,
                        sortable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Updated By", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Actions',
                        field: 'action',
                        html: true,
                        sortable: false,
                        thClass: 'disable-sorting',
                        width: '150px',
                    },
                ],
                rows: [],
                totalRecords: 0,
                serverParams: {
                    columnFilters: {},
                    page: 1,
                    perPage: 25,
                    sort: {
                        field: 'updated_at',
                        type: 'desc',
                    },
                },
                recordsCounts: "",
                selectedRows: 0,
            }

        },
        beforeMount: function () {
            self = this;
            self.checkLogin();
            //self.checkLogin();
        },
        mounted: function () {
            // self = this;
            self.getPermissions();
            self.loadSites();
            // self.loadDepartments();
            self.loadAllDepartments();
        },
        methods: {
            deleteDepartment: function (id) {
                var use = [];
                var contactCnt = 0;
                if (id == 0) {
                    var data = this.$refs['DepartmentList'].selectedRows;
                    // var self = this;
                    for (var i = 0; i < data.length; i++) {
                        use.push(this.$refs['DepartmentList'].selectedRows[i].id)
                    }
                } else {
                    use.push(id);
                }
                $.each(use, function (i) {
                    $.each(self.rows, function (j) {
                        if (use[i] == self.rows[j].id) {
                            contactCnt += self.rows[j].contact_cnt;
                        }
                    });
                });
                if (contactCnt > 0) {
                    self.$swal({
                        title: 'Sorry...!',
                        type: 'warning',
                        html: "Sorry, You can't delete department(s) <br> as it is linked with other data.",
                        showConfirmButton: false,
                        timer: 5000,
                    });
                } else {
                    self.$swal({
                        title: 'Are you sure?',
                        text: 'Are you sure that you want to delete Department(s)!',
                        type: 'info',
                        confirmButtonText: 'OK',
                        showCancelButton: true,
                        // showCloseButton: true,
                        showLoaderOnConfirm: true
                    }).then((result) => {
                        if (result.value) {
                            var fields = {
                                delete_arr: use,
                            }
                            var config = {
                                headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                            };
                            HTTP.post("ce-deleteDepartment", fields, config)
                                    .then(function (response) {
                                        self.loadAllDepartments();
                                    })
                                    .catch(function (err) {
                                        if (err.response.status == 0) {
                                            self.error = "Remote server can not be reachable";
                                        } else {
                                            //redirect to login page if user not authenticated
                                            if (err.response.status == 401) {
                                                //clear previous data
                                                localStorage.removeItem("user_obj");
                                                localStorage.removeItem("api_token");
                                                localStorage.removeItem("profile_image");
                                                self.$router.push("/login");
                                                // EventBus.$emit("logged-in", true, "", "");
                                            }
                                            self.error = err.response.data.message;
                                        }
                                    });
                        }
                    });
                }
            },
            addDepartment() {
                self.$router.push('/backend/adddepartment');
            },

            updateParams(newProps) {
                self.serverParams = Object.assign({}, self.serverParams, newProps);
            },
            onPageChange(params) {
                self.updateParams({page: params.currentPage});
                self.loadAllDepartments();
            },
            onPerPageChange(params) {
                if (params.currentPerPage != self.serverParams.perPage) {
                    self.updateParams({perPage: params.currentPerPage});
                    self.totalRecords = self.totalRecords;
                    self.loadAllDepartments();
                }
            },
            onColumnFilter(params) {
                self.updateParams(params);
                {
                    field: ('id');
                    field: ('site_name');
                    field: ('updated_at');
                    field: ('updated_by');
                }
                ;
                self.serverParams.page = 1;
                var filtersPr = JSON.parse(JSON.stringify(self.serverParams));
                var filters = filtersPr.columnFilters;

                if (self.firstLoad == 1 || filters.id || filters.site_name || filters.updated_at || filters.updated_by) {
                    self.loadAllDepartments();
                }

            },
            selectionChanged() {
                self.selectedRows = (self.$refs['DepartmentList'].selectedRows).length;
                /* console.log(self.selectedRows); */
            },
            onSortChange(params) {
                self.updateParams({
                    sort: {
                        type: params[0].type,
                        field: params[0].field,
                    },
                });
                self.loadAllDepartments();
            },
            loadSites() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        get_all: 1
                    }
                };
                HTTP.get("ce-getsite", config)
                        .then(function (response) {
                            self.sitesArr = [];
                            // self.sitesArr = response.data.content;
                            $.each(response.data.content, function (i) {
                                self.sitesArr.push(response.data.content[i].text);
                            });
                            $.each(self.columns, function (i) {
                                if (self.columns[i].field == 'location_name') {
                                    self.columns[i].filterOptions.filterDropdownItems = self.sitesArr;
                                }
                            });
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    // EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            loadAllDepartments: function () {
                self.firstLoad = 1;
                var newPage = Math.ceil(self.totalRecords / self.serverParams.perPage)
                if (newPage) {
                    if (newPage < self.serverParams.page) {
                        self.serverParams.page = newPage;
                    }
                }
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    messageData: self.message,
                    sort: self.serverParams.sort
                };
                self.showLoader();
                HTTP.post('ce-listdepartment', fields, config)
                        .then(function (response) {
                            if (response.data.code == '200') {
                                self.rows = response.data.content.row;
                                self.totalRecords = response.data.content.totalRecords;
                            }
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                if (err.response.status == 0) {
                                    self.error = "Remote server can not be reachable";
                                } else {
                                    //redirect to login page if user not authenticated
                                    if (err.response.status == 401) {
                                        //clear previous data
                                        localStorage.removeItem("user_obj");
                                        localStorage.removeItem("api_token");
                                        localStorage.removeItem("profile_image");
                                        self.$router.push("/login");
                                        //EventBus.$emit("logged-in", true, "", "");
                                    }
                                    self.error = err.response.data.message;
                                }
                            }
                            self.hideLoader();
                        })
            },
            activeOrInactiveState(id, state) {

                var use = [];
                if (id == 0) {
                    var data = this.$refs['DepartmentList'].selectedRows;
                    // var self = this;
                    for (var i = 0; i < data.length; i++) {
                        use.push(this.$refs['DepartmentList'].selectedRows[i].id)
                    }

                }
                self.$swal({
                    title: '',
                    text: 'Are you sure that you want to ' + state + ' Department(s)!',
                    type: 'info',
                    confirmButtonText: 'OK',
                    showCancelButton: true,
                    // showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {

                        var fields = {
                            id: (id != 0) ? id : use,
                            state: state,
                            flag: (id != 0) ? 'oneByOne' : 'all'
                        };

                        var config = {
                            headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                        };

                        self.showLoader();
                        HTTP.post("ce-activeorinactivedepartment", fields, config)
                                .then(function (response) {
                                    if (response.data.code == '200') {
                                        self.loadAllDepartments();
                                        if (response.data.content > 0) {
                                            //alert(response.data.content + " User has been already " + txtValue);
                                        }
                                    }
                                    self.hideLoader();
                                })
                                .catch(function (error) {
                                    self.hideLoader();
                                    self.catchHandler(error, function () {});
                                });
                    }
                });

            },
        }
    }
    EventBus.$on('role', function (isLogin, id, name, system_year, userPermissions) {
        if (typeof (self) != "undefined") {
            self.isShowLoggedinfields = isLogin;
            self.roleId = id;
            self.userPermissions = userPermissions;
            self.roleName = name;
            self.system_year = system_year;
        }
    });
</script>



// WEBPACK FOOTER //
// src/components/backend/ManageDepartments/DepartmentsList.vue